"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var Send = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M4.27838495,10.9482095 C3.86703491,10.6458893 3.94702148,10.2309113 4.31637223,10.0349346 L19.3121382,4.03662823 C19.9054413,3.88800049 20.064209,4.35133362 19.9633718,4.68786178 L13.9650654,19.6836278 C13.7031403,20.1693726 13.1974335,20.0228119 13.0517905,19.721615 L10.127322,13.872678 L4.27838495,10.9482095 Z M11.1083803,13.5987265 L13.4492762,18.2805184 L18.6024725,5.39752747 L5.71948164,10.5507238 L10.4012735,12.8916197 L13.1464466,10.1464466 C13.3417088,9.95118446 13.6582912,9.95118446 13.8535534,10.1464466 C14.0488155,10.3417088 14.0488155,10.6582912 13.8535534,10.8535534 L11.1083803,13.5987265 Z" })));
};
Send.displayName = 'Send';
exports.default = Send;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Send.js.map